module.exports = __webpack_public_path__ + "img/icon-white-46.35d50c53.svg";